module.exports = __webpack_public_path__ + "img/play-preenchido.e114811c.svg";